import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useCallback } from 'react';

export interface MarketRegime {
  symbol: string;
  regime: 'trending' | 'ranging' | 'volatile' | 'crisis';
  confidence: number;
  atr_value: number | null;
  adx_value: number | null;
  volume_ratio: number | null;
  computed_at: string;
}

export function useMarketRegimes() {
  const { data: regimes = [], ...rest } = useQuery({
    queryKey: ['market-regimes'],
    queryFn: async (): Promise<MarketRegime[]> => {
      const { data, error } = await supabase
        .from('market_regimes')
        .select('symbol, regime, confidence, atr_value, adx_value, volume_ratio, computed_at');
      if (error) throw error;
      return (data || []) as MarketRegime[];
    },
    refetchInterval: 120000,
    staleTime: 60000,
  });

  const getRegime = useCallback(
    (symbol: string): MarketRegime | null =>
      regimes.find(r => r.symbol === symbol) ?? null,
    [regimes]
  );

  return { regimes, getRegime, ...rest };
}
